import { useTranslation } from 'react-i18next';

interface InlineConfirmProps {
  question: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  danger?: boolean;
}

/**
 * The question before an action, asked on the page in place of the control that started it. Cancel has the
 * focus, so Enter never confirms by accident.
 */
export default function InlineConfirm({ question, confirmLabel, onConfirm, onCancel, danger = false }: InlineConfirmProps) {
  const { t } = useTranslation('common');

  return (
    <div role="group" aria-label={question} style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 13 }}>{question}</span>
      <button type="button" className={`btn sm ${danger ? 'danger' : 'primary'}`} onClick={onConfirm}>
        {confirmLabel}
      </button>
      <button type="button" className="btn sm" autoFocus onClick={onCancel}>
        {t('buttons.cancel', 'Cancel')}
      </button>
    </div>
  );
}
